import { render, staticRenderFns } from "./inflowDetails.vue?vue&type=template&id=5e256d28&scoped=true"
import script from "./inflowDetails.vue?vue&type=script&lang=js"
export * from "./inflowDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e256d28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e256d28')) {
      api.createRecord('5e256d28', component.options)
    } else {
      api.reload('5e256d28', component.options)
    }
    module.hot.accept("./inflowDetails.vue?vue&type=template&id=5e256d28&scoped=true", function () {
      api.rerender('5e256d28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wovenBagManagement/detailManagement/cmp/inflowDetails.vue"
export default component.exports